export const Stack = {
  defaultProps: {
    spacing: 4,
  },
}
